import React, { useState } from 'react'
import './myInformation.less'
import { Form, Input, Button, Modal, message } from "antd";
import { API } from "@/http/api";
import http from "@/http";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

class LoginForm extends React.Component {
  state = {
    captchaImage: '',
    uuid: '',
    loading: false,
  };
  goLink = (item) => {
    window.open(item.link)
  }
  componentDidMount() {
    this.getCaptchaImage();
  }

  // 获取验证码
  getCaptchaImage = (result, phone) => {
    const config = {
      api: API.userCaptchaImage,
      data: {
      },
    }
    http(config).then((res) => {
      if (res.code === 200) {
        const captchaEnabled = res.result.captchaEnabled
        if (captchaEnabled) {
          this.setState({
            captchaImage: "data:image/gif;base64," + res.result.img,
            uuid: res.result.uuid
          });
        }
      }
    })
  }
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ loading: true });
        const config = {
          api: API.userEditUserInfo,
          data: {
            newMobile: this.props.mobile,
            newPassword: values.newPassword,
            originalPassword: values.originalPassword,
          },
        }
        http(config).then((res) => {
          if (res.code == 200) {
            this.setState({ loading: false });
            this.props.setVisible(false);
            // 重置表单
            message.success('修改成功');
          } else {
            this.setState({ loading: false });
            this.props.setVisible(false);
            // 重置表单
            // message.error(res.msg);
          }
        })
      }
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <div style={{ height: "300px" }}>
          <Form ref={this.formRef} onSubmit={this.handleSubmit} className="form">
            <Form.Item label="手机号码/账号">
              <Input defaultValue={this.props.mobile} disabled />
            </Form.Item>
            <Form.Item label="原始密码" className="code_item">
              {getFieldDecorator("originalPassword", {
                rules: [{ required: true, message: "请输入您的原始密码" }]
              })(
                <Input.Password
                  autoComplete="off"
                  className="login-input"
                  placeholder="请输入您的原始密码"
                />
              )}
            </Form.Item>
            <Form.Item label="新密码">
              {getFieldDecorator("newPassword", {
                rules: [{ required: true, message: "请输入您的新密码" }]
              })(
                <Input.Password
                  autoComplete="off"
                  className="code"
                  placeholder="请输入您的新密码"
                />
              )}
            </Form.Item>
            <Button className="reset-btn" type="primary" htmlType="submit" loading={this.state.loading} block>确定</Button>
          </Form>
        </div>
      </div>
    );
  }
}
const WrappedLoginForm = Form.create({ name: 'LoginForm' })(LoginForm);

class my extends React.Component {
  state = {
    visible: false,
    form: {}
  }
  setVisible = (visible) => {
    this.setState({ visible });
  };
  componentDidMount() {
    const config = {
      api: API.usergetLoginInfo,
    };
    http(config).then((res) => {
      if (res.code == 200) {
        this.setState({
          form: res.result,
        });
      }
    });
  }
  handleCloseModal = () => {
    this.setState({
      visible: false
    })
  }
  changePassword = () => {
    this.setState({
      visible: true
    })
  }

  render() {
    return (
      <div className='my'>
        <div className='form'>
          <Form className="login-form" {...layout}>
            <Form.Item label="手机号码/账号">
              <span className='item'>{this.state.form.mobile ? this.state.form.mobile : "-"}</span>
            </Form.Item>
            <Form.Item label="用户名">
              <span className='item'>{this.state.form.userName ? this.state.form.userName : "-"}</span>
            </Form.Item>
            <Form.Item label="企业名称">
              <span className='item'>{this.state.form.organizationName ? this.state.form.organizationName : "-"}</span>
            </Form.Item>
            <Form.Item label="企业统一信用代码">
              <span className='item'>{this.state.form.organizationCode ? this.state.form.organizationCode : "-"}</span>
            </Form.Item>
            <Form.Item label="电子邮箱">
              <span className='item'>{this.state.form.email ? this.state.form.email : "-"}</span>
            </Form.Item>
          </Form>
          <Button onClick={this.changePassword} style={{ marginTop: '24px', height: '40px', fontSize: '16px', width: '60%' }} type="primary" htmlType="submit" block>修改密码</Button>
        </div>
        <Modal
          title="修改密码"
          width={400}
          centered={true}
          visible={this.state.visible}
          onCancel={this.handleCloseModal}
          footer={null}
        >
          <div>
            <WrappedLoginForm mobile={this.state.form.mobile} setVisible={this.setVisible}  {...this.props}></WrappedLoginForm>
          </div>
        </Modal>
      </div>
    )
  }

}

export default my
